<div class="servicenumber-auth-container" *ngIf="canViewAuthSection()" [testId]="'servicenumber-auth-container'">
  <section class="auth-entry-surface" [testId]="'servicenumber-auth-entry'">
    <div class="auth-entry-header">
      <div class="auth-heading">
        <h3>{{ 'servicenumber.auth.title' | i18n }}</h3>
        <p>{{ authDesc }}</p>
      </div>
      <div class="auth-entry-actions">
        <button
          nz-button
          class="secondary-button copy-entry-button"
          [disabled]="!entryPageUrl"
          [nzLoading]="entryPageUrlLoading"
          (click)="copyEntryPageUrl()"
          [testId]="'servicenumber-auth-copy-entry-button'"
        >
          <nz-icon nzType="copy" nzTheme="outline" />
          {{ 'servicenumber.auth.copy-entry-link' | i18n }}
        </button>
        <nz-tag nzColor="blue">{{ 'servicenumber.auth.entry-tag' | i18n }}</nz-tag>
      </div>
    </div>

    <form nz-form nzLayout="vertical" [formGroup]="authForm" class="auth-form compact-auth-form" [testId]="'servicenumber-auth-form'">
      <div class="auth-fields-grid">
        <nz-form-item class="auth-mobile-field">
          <nz-form-label nzRequired>{{ 'servicenumber.auth.batch-mobiles' | i18n }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'servicenumber.auth.invalid-mobile' | i18n">
            <textarea
              nz-input
              formControlName="mobiles"
              [placeholder]="'servicenumber.auth.mobiles-placeholder' | i18n"
              [nzAutosize]="{ minRows: 2, maxRows: 3 }"
              [testId]="'servicenumber-auth-mobiles-input'"
            ></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="auth-remark-field">
          <nz-form-label>{{ 'servicenumber.auth.default-remark' | i18n }}</nz-form-label>
          <input
            nz-input
            formControlName="remark"
            [placeholder]="'servicenumber.auth.remark-placeholder' | i18n"
            testId="servicenumber-auth-remark-input"
          />
        </nz-form-item>
        <div class="auth-submit-row">
          <button
            type="button"
            nz-button
            nzType="primary"
            class="add-auth-button"
            [nzLoading]="saving"
            (click)="saveMobiles()"
            [testId]="'servicenumber-auth-save-button'"
          >
            <nz-icon nzType="plus" nzTheme="outline" />
            {{ 'servicenumber.auth.add' | i18n }}
          </button>
        </div>
      </div>
    </form>
  </section>

  <section class="auth-list-surface" [testId]="'servicenumber-auth-list'">
    <div class="auth-list-header">
      <div class="auth-heading">
        <h3>{{ 'servicenumber.auth.list-title' | i18n }}</h3>
        <p
          ><span class="record-count">{{ total }}</span> {{ 'servicenumber.auth.records' | i18n }}</p
        >
      </div>
      <div class="auth-list-actions">
        <input
          nz-input
          class="auth-search"
          [placeholder]="'servicenumber.auth.search-placeholder' | i18n"
          (keyup.enter)="onSearch($any($event.target).value)"
          [testId]="'servicenumber-auth-search-input'"
        />
        <button nz-button class="secondary-button" (click)="loadData()" [testId]="'servicenumber-auth-refresh-button'">
          <nz-icon nzType="reload" nzTheme="outline" />
          {{ 'common.refresh' | i18n }}
        </button>
        <button
          nz-button
          nzDanger
          class="secondary-button"
          [disabled]="selectedIds.size === 0"
          (click)="confirmDelete(selectedIdList)"
          [testId]="'servicenumber-auth-batch-delete-button'"
        >
          {{ 'servicenumber.auth.batch-delete' | i18n }}
        </button>
      </div>
    </div>

    <nz-table
      class="auth-table"
      [nzData]="listOfData"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzLoading]="loading"
      [nzScroll]="{ x: '860px' }"
      [nzNoResult]="emptyAuthList"
      nzSize="small"
      [testId]="'servicenumber-auth-table'"
    >
      <thead>
        <tr>
          <th [nzWidth]="'48px'" [nzChecked]="allChecked" [nzIndeterminate]="indeterminate" (nzCheckedChange)="onSelectAll($event)"></th>
          <th [nzWidth]="'180px'">{{ 'servicenumber.auth.mobile' | i18n }}</th>
          <th [nzWidth]="'220px'">{{ 'servicenumber.auth.remark' | i18n }}</th>
          <th [nzWidth]="'140px'">{{ 'common.status' | i18n }}</th>
          <th [nzWidth]="'180px'">{{ 'servicenumber.auth.create-time' | i18n }}</th>
          <th [nzWidth]="'140px'">{{ 'common.actions' | i18n }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of listOfData; trackBy: trackById">
          <td [nzChecked]="isSelected(item.id)" (nzCheckedChange)="onSelect(item.id, $event)"></td>
          <td class="mobile-cell">{{ item.countryCode }} {{ item.mobile }}</td>
          <td>{{ item.remark || '-' }}</td>
          <td>
            <nz-tag [nzColor]="getStatusColor(item.status)">{{ getStatusLabel(item.status) }}</nz-tag>
          </td>
          <td>{{ item.createTime ? (item.createTime | date: 'yyyy-MM-dd HH:mm') : '-' }}</td>
          <td class="action-cell">
            <nz-switch
              [ngModel]="item.status === 'Enable'"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="setStatus(item, $event)"
              [nzCheckedChildren]="'servicenumber.auth.status.enable' | i18n"
              [nzUnCheckedChildren]="'servicenumber.auth.status.disable' | i18n"
              [testId]="'servicenumber-auth-status-switch-' + item.id"
            />
            <button
              nz-button
              nzType="link"
              nzDanger
              class="delete-link"
              (click)="confirmDelete([item.id])"
              [testId]="'servicenumber-auth-delete-' + item.id"
            >
              {{ 'common.delete' | i18n }}
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>

    <ng-template #emptyAuthList>
      <div class="auth-empty-state" [testId]="'servicenumber-auth-empty'">
        <div class="auth-empty-icon">
          <nz-icon nzType="safety-certificate" nzTheme="outline" />
        </div>
        <div class="auth-empty-title">{{ 'servicenumber.auth.empty-title' | i18n }}</div>
        <div class="auth-empty-desc">{{ 'servicenumber.auth.empty-desc' | i18n }}</div>
      </div>
    </ng-template>

    <div class="auth-pagination" *ngIf="total > pageSize">
      <nz-pagination
        [nzPageIndex]="pageIndex"
        [nzPageSize]="pageSize"
        [nzTotal]="total"
        (nzPageIndexChange)="onPageIndexChange($event)"
        testId="servicenumber-auth-pagination"
      />
    </div>
  </section>
</div>
